/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditordishdescriptionplaceholder4Inputs */

const en_menueditordishdescriptionplaceholder4 = /** @type {(inputs: Menueditordishdescriptionplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sides or ingredients (optional)`)
};

const de_menueditordishdescriptionplaceholder4 = /** @type {(inputs: Menueditordishdescriptionplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beilagen oder Zutaten (freiwillig)`)
};

/**
* | output |
* | --- |
* | "Sides or ingredients (optional)" |
*
* @param {Menueditordishdescriptionplaceholder4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditordishdescriptionplaceholder4 = /** @type {((inputs?: Menueditordishdescriptionplaceholder4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditordishdescriptionplaceholder4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditordishdescriptionplaceholder4(inputs)
	return de_menueditordishdescriptionplaceholder4(inputs)
});
export { menueditordishdescriptionplaceholder4 as "menuEditorDishDescriptionPlaceholder" }